import React, { useEffect, useState } from "react";
import { classNames } from "../../helpers";

type RoomContainerProps = {
  meetingWindow: JSX.Element;
  trailingContent: JSX.Element;
  windowSize: number; // 0-100
  showTrailingContent: boolean;
  trailingMaxWidth: "360px" | "640px";
};

export default function RoomContainer(props: RoomContainerProps) {
  const {
    meetingWindow,
    trailingContent,
    windowSize,
    showTrailingContent,
    trailingMaxWidth,
  } = props;

  const calculatedWindowSize = showTrailingContent ? windowSize : 100;
  const trailingContentSize = 100 - calculatedWindowSize;

  return (
    <div
      className={classNames(
        "w-screen sm:h-screen flex flex-col sm:flex-row",
        !!showTrailingContent ? "gap-2 h-[100vh]" : "h-[87vh] h-[calc(100vh-72px)]", // we added the h-[87vh] as fallback in case the browser doesn't support calc()
      )}
    >
      <div
        className={`flex-1 transition-[flex-basis] duration-300 overflow-hidden ${
          showTrailingContent ? "landscape-flex-base-50" : ""
        }`}
      >
        {meetingWindow}
      </div>
      <div
        className={`block sm:hidden transition-[flex-basis] duration-300 overflow-x-hidden bg-white overflow-y-auto`}
        style={{ flexBasis: `${trailingContentSize}%` }}
      >
        {trailingContent}
      </div>
      <div
        className={`hidden sm:block transition-[flex-basis] duration-300 overflow-hidden ${
          showTrailingContent ? "landscape-flex-base-50" : ""
        }`}
        style={{
          flexBasis: `min(${trailingContentSize}%, ${trailingMaxWidth})`,
        }}
      >
        {trailingContent}
      </div>
    </div>
  );
}
